import React from 'react'
import withIcon from '@/components/withIcon'

const IconCloudRain = ({ className }) => {
  return (
    <svg
      className={className}
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.856 35.2988L14.1752 45.159"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="22.9256"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12.8275 35.0371L6.94525 45.2481"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="22.9256"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M26.8844 35.2988L21.2037 45.159"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="22.9256"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M33.913 35.2988L28.2322 45.159"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="22.9256"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M21.1659 30.4386C38.1577 30.4386 34.2404 30.4386 36.7092 30.4386C42.3899 30.4386 47 26.2414 47 21.0796C47 15.9052 42.3899 11.7206 36.7092 11.7206C35.9912 11.7206 35.2985 11.7832 34.6309 11.9085C32.7163 7.44829 27.9551 4.29104 22.3751 4.29104C15.1073 4.27851 9.21249 9.64082 9.21249 16.2435V16.4189C9.04874 16.4064 8.8724 16.4064 8.70865 16.4064C4.45126 16.4064 1 19.5511 1 23.4225C1 27.2939 4.45126 30.4386 8.70865 30.4386C10.3713 30.4386 12.0214 30.4386 21.1659 30.4386Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="22.9256"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default withIcon(IconCloudRain)
